import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/script.js");
